import axios from 'axios'

export async function sendWelcomeEmails(customerId) {
    const response = await axios.post(
        `${process.env.API_URL}/hotswaps/welcome-email/${customerId}`
    )
    return response.data
}

export async function getCustomerUsers(customer_id, searchTerm) {
    const url = `${process.env.API_URL}/customers/${customer_id}/users`
    const params = {}

    if (searchTerm) {
        params.searchTerm = searchTerm
    }

    return axios.get(url, { params }).then(response => response.data)
}
